import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { ViewPopupLogin } from '../ui_popup/ui_popup_membership_incentive/ViewPopupLogin.ts';
import { showSimpleDialog } from '../ui_popup/showSimpleDialog.ts';
import { getNestedTranslation } from '@colonist/i18n';
import { ClientUserState } from '../ClientUserState.ts';
import { PaymentMethod } from '../../../../shared/store/BaseColonistStoreProduct.ts';
import { ColonistMembershipProduct } from '../../../../shared/store/ColonistMembershipProduct.ts';
import { StoreItemCategory } from '../../../../shared/entity_datas/StoreEnums.ts';
export function doActionIfLoggedIn(action) {
    var _ClientUserState_userState;
    if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn) {
        action();
        return;
    }
    if (UIUtilsEjsVariables.isUserOnDiscord) {
        action();
        return;
    }
    new ViewPopupLogin();
}
function canBuy(price) {
    if (ClientUserState.userState == undefined) return false;
    if (ClientUserState.userState.items.colonistCoins == undefined) return true;
    if (ClientUserState.userState.items.colonistCoins >= price) return true;
    return false;
}
export function areYouSureToBuy(itemDetail, action, onFailure) {
    const price = itemDetail.salePrice == undefined ? itemDetail.price : itemDetail.salePrice;
    if (!canBuy(price)) {
        if (onFailure) {
            onFailure();
            return;
        }
        const coinSection = document.getElementById('coins');
        coinSection === null || coinSection === void 0 ? void 0 : coinSection.scrollIntoView({
            behavior: 'smooth'
        });
        return;
    }
    const popupBody = getNestedTranslation({
        key: 'strings:storePage.purchaseItem?.body',
        options: {
            price: price
        }
    }, {
        itemName: itemDetail.name
    });
    showSimpleDialog({
        title: {
            key: 'strings:storePage.purchaseItem?.title'
        },
        body: popupBody,
        onConfirm: action,
        showCancelBtn: true
    });
}
export function areYouSureToBuyFounderDiscount(itemDetail, action) {
    showSimpleDialog({
        title: {
            key: 'strings:storePage.purchaseItem?.title'
        },
        body: {
            key: 'strings:storePage.purchaseItem?.body',
            options: {
                context: 'founder'
            }
        },
        onConfirm: action,
        showCancelBtn: true
    });
}
export function doActionIfCanGiftMembership(action, receiverUsername) {
    var _ClientUserState_userState;
    if (!((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn)) {
        new ViewPopupLogin();
        return;
    }
    if (receiverUsername === null || receiverUsername === void 0 ? void 0 : receiverUsername.includes('#')) {
        showSimpleDialog({
            title: {
                key: 'strings:popups.errors.giftMembership.title'
            },
            body: {
                key: 'strings:popups.errors.giftMembership.guestsCantReceiveGifts'
            }
        });
        return;
    }
    action();
}
export function getManageSubscriptionPopupBody() {
    var _ClientUserState_userState, _ClientUserState_userState1;
    const paymentMethod = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.membershipPaymentMethod;
    if (paymentMethod == PaymentMethod.Apple) return {
        key: 'strings:storePage.manageMembership.body',
        options: {
            context: 'updateOnAppStore'
        }
    };
    if (paymentMethod == PaymentMethod.Android) return {
        key: 'strings:storePage.manageMembership.body',
        options: {
            context: 'updateOnGooglePlay'
        }
    };
    if (paymentMethod != PaymentMethod.Discord) return {
        key: 'strings:storePage.manageMembership.body',
        options: {
            context: 'updateOnWeb'
        }
    };
    const discordMembership = (_ClientUserState_userState1 = ClientUserState.userState) === null || _ClientUserState_userState1 === void 0 ? void 0 : _ClientUserState_userState1.items.getCurrentMembership();
    if (discordMembership == undefined) throw new Error('Membership not found');
    const hasDiscordAnnualMembership = ColonistMembershipProduct.isAnnualMembership(discordMembership.type);
    if (hasDiscordAnnualMembership) return {
        key: 'strings:storePage.manageMembership.body',
        options: {
            context: 'waitForExpiration'
        }
    };
    return {
        key: 'strings:storePage.manageMembership.body'
    };
}
export function isPurchaseUnavailableOnPlatform() {
    return UIUtilsEjsVariables.isUserOnDiscordMobile;
}
export function showUnavailableOnMobilePopup() {
    const popupTitle = {
        key: 'strings:popups.unavailableOnMobile.title'
    };
    const popupBody = {
        key: 'strings:popups.unavailableOnMobile.body'
    };
    showSimpleDialog({
        title: popupTitle,
        body: popupBody
    });
}
export function shouldHideCoinsSection(forceSubscription) {
    if (!UIUtilsEjsVariables.isUserOnDiscord) return false;
    if (!UIUtilsEjsVariables.canPurchaseCoinsOnDiscord && forceSubscription) return true;
    return false;
}
export function getStoreCategoryString(category) {
    switch(category){
        case StoreItemCategory.PresalePack:
            return 'presale';
        case StoreItemCategory.Expansion:
            return 'expansions';
        case StoreItemCategory.Map:
            return 'maps';
        case StoreItemCategory.Icon:
            return 'avatars';
        case StoreItemCategory.Color:
            return 'colors';
        case StoreItemCategory.Consumable:
            return 'consumables';
        case StoreItemCategory.Membership:
            return 'membership';
    }
}
